import React from 'react';
import PropTypes from 'prop-types';
import Message from '../i18n/Message';
export default class StockLabel extends React.Component {
    constructor(props) {
        super(props);
    }
    render() {
        let numberOfStocks = Number(this.props.numberOfStocks);
        let numberOfStocksFormatted = numberOfStocks.toLocaleString();
        let salesMethodMaker = Boolean(this.props.salesMethodMaker);
        let salesMethodLabel = this.props.salesMethodLabel;
        if (!this.props) {
            return null;
        }
        if (salesMethodMaker) {
            return (React.createElement("p", { className: "item-stock green", dangerouslySetInnerHTML: { __html: salesMethodLabel } }));
        }
        else {
            if (numberOfStocks > 9) {
                return (React.createElement("p", { className: "item-stock green" },
                    React.createElement(Message, { messageId: "stock.inStock", values: { numberOfStocks: numberOfStocksFormatted }, escapeHtml: true })));
            }
            else if (numberOfStocks > 0 && numberOfStocks <= 9) {
                return (React.createElement("p", { className: "item-stock red" },
                    React.createElement(Message, { messageId: "stock.limitedStock", values: { numberOfStocks: numberOfStocksFormatted } })));
            }
            else if (numberOfStocks <= 0) {
                return (React.createElement("p", { className: "item-stock noStock" },
                    React.createElement(Message, { messageId: "stock.noStock" })));
            }
            else {
                return null;
            }
        }
    }
}
StockLabel.numberOfStocks = {
    numberOfStocks: PropTypes.number.isRequired,
    salesMethodMaker: PropTypes.bool.isRequired,
    salesMethodLabel: PropTypes.string.isRequired,
};
